import Header from '../components/Header';
import Blog from '../components/Blog';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';

const BlogPage = () => {
  return (
    <>
      <Header />
      <div style={{marginTop: '64px'}}>
        <Blog />
      </div>
      <Footer />
      <WhatsAppFloat />
    </>
  );
};

export default BlogPage;
